import(/* webpackMode: "eager" */ "/vercel/path0/apps/www.volebnikalkulacka.cz/app/global-error.tsx");
